import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { getGoToBrandReferralsCTA } from "./shared";

export const BrandReferralHowDoReferralsWorkIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (_context) => {
      return BRAND_REFERRALS_HOW_REFERRALS_WORK_TITLE(strictLocalize);
    },

    descriptionBuilder(_context) {
      return [BRAND_REFERRALS_HOW_REFERRALS_WORK_DESCRIPTION(strictLocalize)];
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getGoToBrandReferralsCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getGoToBrandReferralsCTA(context, strictLocalize)?.getLink?.();
      },
    },
  };
};

const BRAND_REFERRALS_HOW_REFERRALS_WORK_TITLE = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "How do brand referrals work ",
  });

const BRAND_REFERRALS_HOW_REFERRALS_WORK_DESCRIPTION = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "You can earn credit when you refer a brand to sell on Faire. To be eligible for the credit, the brand must use your link or add you as their referrer when they sign up. Note that self-referrals or verbal referrals do not qualify.",
  });
